interface LeadEngineFeatureFlag {
  flagKey: string
  defaultValue: boolean
}

export const FSM_390_USE_LEAD_ENGINE_LEAD_GEN_ENDPOINTS: LeadEngineFeatureFlag = {
  flagKey: 'fsm-390_funnel_use_lead_engine_lead_gen_endpoints',
  defaultValue: false
}
